import axios from '@main/axios';
import Handlebars from 'handlebars';
import nominationDetailsTemplate from '@partials/nomination-details.hbs?raw';
import {Modal} from '@main/components/modal/modal';

/**
 * Класс для управления списком номинаций и отображением детальной информации
 */
class Nominations {
  /**
   * Создает экземпляр класса Nominations
   * @param {HTMLElement} listElement - HTML элемент списка номинаций
   */
  constructor(listElement) {
    /** @type {HTMLElement} */
    this.listElement = listElement;

    /** @type {string} */
    this.url = this.listElement.dataset.url;

    /** @type {HTMLElement|null} */
    this.modal = document.querySelector('.js-modal[data-modal-name="nomination"]');

    /** @type {HandlebarsTemplateDelegate} */
    this.nominationCard = Handlebars.compile(nominationDetailsTemplate);

    this.bindEventListeners();
  }

  /**
   * Привязывает обработчики событий
   * @private
   */
  bindEventListeners() {
    this.listElement.addEventListener('click', (e) => {
      const nominationCardElement = e.target.classList.contains('js-nomination')
        ? e.target
        : e.target.closest('.js-nomination');

      if (nominationCardElement) {
        e.preventDefault();
        const id = nominationCardElement.dataset.id;

        Modal.open(this.modal);
        this.getDescriptionNomination(id);
      }
    });
  }

  /**
   * Получает детальное описание номинации по ID
   * @param {string|number} id - Идентификатор номинации
   * @returns {Promise<void>}
   * @private
   */
  async getDescriptionNomination(id) {
    try {
      const response = await axios.get(this.url, {
        params: {id},
      });

      if (response.data?.success && response.data?.data) {
        this.addDescription(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Добавляет детальное описание номинации в модальное окно
   * @param {Object} data - Данные номинации
   * @private
   */
  addDescription(data) {
    if (!this.modal) return;

    const modalContent = this.modal.querySelector('.js-modal-content');

    if (!modalContent) {
      return;
    }

    // Очищаем предыдущее содержимое перед добавлением нового
    modalContent.innerHTML = '';

    try {
      const dataNomination = this.nominationCard({nomination: data});
      modalContent.insertAdjacentHTML('afterbegin', dataNomination);
    } catch (error) {
      console.error(error);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-nominations-list').forEach((el) => new Nominations(el));
});
